// extracted by mini-css-extract-plugin
module.exports = {"item":"creatableItem_item__1nDx0","icon":"creatableItem_icon__2pr-g"};